import { BaseContainerModel } from '../../../base-container.model';
import {bl_del_driver_hdr_RowClass, bl_del_driver_ext_RowClass} from '../../../../dbschema';

export class DriverDeliveryHeaderContainerModel extends BaseContainerModel {
  bl_del_driver_hdr: bl_del_driver_hdr_RowClass = new bl_del_driver_hdr_RowClass();
  bl_del_driver_ext: bl_del_driver_ext_RowClass[] = [];
}